<template>
    <v-navigation-drawer
      v-model="availableUsersDrawer"
      fixed
      clipped
      right
      width="420"
    >
      <v-card>
        <v-card-title class="text-h5">
          <span>{{ $t('chat.availableUsers.title') }}</span>
        </v-card-title>

        <v-list dense>
          <v-list-item-group
            v-model="usersSelected"
            active-class="primary--text"
            multiple>

            <template v-for="(user) in availableUsers">
              <v-list-item :key="user.username" :disabled="userIsMember(user)" :value="user.chat_user_id">
              <template v-slot:default="{ active }">
                <v-list-item-action>
                  <StatusAvatar :user="user"/>
                </v-list-item-action>

                <v-list-item-content>

                  <v-list-item-title v-text="user.name"></v-list-item-title>
                  <v-list-item-subtitle
                    class="text--grey"
                    v-text="user.chat_username"
                  ></v-list-item-subtitle>

                </v-list-item-content>

                <v-list-item-action>
                  <v-list-item-action-text v-text="selectText(user)"></v-list-item-action-text>

                  <v-icon
                    color="primary lighten-1"
                  >
                    {{selectIcon(user, active)}}
                  </v-icon>
                </v-list-item-action>
              </template>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>

      </v-card>

      <template v-slot:append>
        <div class="d-flex flex-row pa-2">
          <v-btn
          class="ma-2"
          @click="submit()"
          :disabled="usersSelected.length == 0"
          color="primary">
            {{ $t('chat.availableUsers.btn.submit') }} ({{ usersSelected.length }})
          </v-btn>
          <v-btn
          class="ma-2"
          @click="closeDrawer()"
          text>
            {{ $t('chat.availableUsers.btn.cancel') }}
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import StatusAvatar from '@/components/buddies/status_avatar'

export default {
  name: 'chat-availableChannelDrawer',
  data () {
    return {
      usersSelected: [],
      drawer: false
    }
  },
  created () {
    this.getUsers()
  },
  computed: {
    ...mapGetters({
      availableUsers: 'chat/users',
      channelMembers: 'chat/channelMembers',
      channel: 'chat/contextMenuChannel',
      getAvailableUsersDrawer: 'chat/availableUsersDrawer'
    }),
    availableUsersDrawer: {
      get () {
        return this.getAvailableUsersDrawer
      },
      set () {
        // shall not be fill but raise warning otherwise
      }
    }
  },
  components: {
    StatusAvatar
  },
  methods: {
    ...mapActions({
      getUsers: 'chat/getUsers',
      closeDrawer: 'chat/availableUsersDrawer',
      addMemberToChannel: 'chat/addMemberToChannel'
    }),

    submit () {
      this.usersSelected.forEach((userId) => {
        this.addMemberToChannel(userId)
      })
      this.closeDrawer()
    },

    navChannelContextMenu (contextMenu, channel) {
      const channelAction = contextMenu.key
      const options = { channelAction: channelAction, channel: channel }
      this.openChannelActionDialog({ options })
    },

    userIsMember (user) {
      const foundUser = this.channelMembers.find((member) => member.username === user.chat_username)
      return foundUser !== undefined
    },

    selectText (user) {
      return this.userIsMember(user)
        ? this.$t('chat.availableUsers.member')
        : ''
    },

    selectIcon (user, active) {
      if (this.userIsMember(user)) {
        return 'mdi-account-circle'
      } else {
        return active
          ? 'mdi-account-check'
          : 'mdi-account-check-outline'
      }
    }
  }
}
</script>

<style scoped>
</style>
